import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { Questionnaire } from "../../interfaces/questionnaire";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class QuestionnaireService {
  env: any = environment;

  constructor(private http: HttpClient, private router: Router) {}

  getQuestionnairesByProjectId(projectId): Promise<Questionnaire[]> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("projectId", projectId);
      this.http
        .get<any>(this.env.managirUrl + "/questionnaires", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.QuestionnaireResponse.questionnaires);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  getQuestionnaireByShortId(shortId): Observable<Questionnaire> {
    return this.http
      .get<any>(this.env.managirUrl + "/questionnaires", {
        params: new HttpParams().set("shortId", shortId),
        headers: { "Content-Type": "application/json" },
      })
      .map((response) => response.QuestionnaireResponse.questionnaires[0]);
  }

  createQuestionnaire(questionnaire): Promise<Questionnaire> {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/questionnaires", questionnaire, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.QuestionnaireResponse.questionnaires[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  saveQuestionnaire(questionnaire) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(
          this.env.managirUrl + "/questionnaires/" + questionnaire._id,
          questionnaire,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.QuestionnaireResponse.questionnaires[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteQuestionnaireById(questionnaireId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(
          this.env.managirUrl + "/questionnaires/" + questionnaireId,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/questionnaire/questionnaire.service.ts